import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/main';


import User from '../store/modules/user';
// import MasterData from './master_data';
import VdoSet from '../store/modules/vdo-set/vdo-set/index';
import VdoSetUnit from '../store/modules/vdo-set/vdo-set-unit/index';
import VdoSetTopic from '../store/modules/vdo-set/vdo-set-topic/index';
import CommonData from '../store/modules/common-data/index';
import Profile from '../store/modules/profile';
import Courses from '../store/modules/courses';
import StudentEnroll from '../store/modules/student-enroll';
import StudentEnrollDetail from '../store/modules/student-enroll-detail';
import Examination from '../store/modules/examination';
import ClassRoomType from '../store/modules/class-room/classRoomType';
import ClassRoomOwned from '../store/modules/class-room/classRoomOwned';
import ClassRoom from '../store/modules/class-room/class-room/index';
import Degree from '../store/modules/common-data/degree';
import Subject from '../store/modules/common-data/subject/index';
import SubjectGroup from '../store/modules/common-data/subject-group';
import Student from '../store/modules/profile/student/index';
import Teacher from '../store/modules/profile/teacher/index';
import CourseOutline from '../store/modules/courses/course-outline/index';
import CourseOutlineRegistration from '../store/modules/courses/course-outline-registration/index';
import AcademicPeriod from '../store/modules/common-data/academic-period';
import AcademicPeriodConfig from '../store/modules/common-data/academicPeriodConfig';
import ClassSection from '../store/modules/courses/class-section/index';
import LiveClassSchedule from '../store/modules/live-class/live-class-schedule/index';
import VdoLiveSet from '../store/modules/live-class/vdo-live-set/index';
import VdoLiveSetTopic from '../store/modules/live-class/vod-live-set-topic/index';
import Exam from '../store/modules/examination/exam/index';
import ExamQuestionType from '../store/modules/examination/exam-question-type/index';
import ClassAssignment from '../store/modules/courses/class-assignment/index';
import ClassMaterial from '../store/modules/courses/class-material/index';
import StudentAssignment from '../store/modules/student-assignment/index';
import StudentScore from '../store/modules/student-score/index';
import StudentUnitLearn from '../store/modules/student-unit-learn/student-unit-learn/index';
import StudentTopicLearn from '../store/modules/student-unit-learn/student-topic-learn/index';
import Assessment from '../store/modules/common-data/assessment/index';
import CourseOutlineAssessment from '../store/modules/courses/course-outline-assessment/index';
import CourseOutlineUnit from '../store/modules/courses/course-outline-unit/index';
import Upload from '../store/modules/upload/index';
import CourseFaq from '../store/modules/class-room/course-faq/index';
import WebBoard from "../store/modules/web-board";
import WebBoardReply from "../store/modules/web-board-reply";
import PrivateMessage from "../store/modules/private-message";
import PrivateMessageReply from "../store/modules/private-message-reply";
import Notification from "../store/modules/notification";
import AdvisorOnlineSchedule from "../store/modules/advisor-online-schedule";
import InfoGroup from "../store/modules/university-news/info-group";
import InfoTopic from "../store/modules/university-news/info-topic";
import YeaLinkImportDate from "../store/modules/yea-link-import-data/index";
import SystemConfig from '@/store/modules/system/system-config/index';

import state from "./modules/theme/state"
import getters from "./modules/theme/getters"
import mutations from "./modules/theme/mutations"
import actions from "./modules/theme/actions"

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  state,
  mutations:
    {
      ...mutations,
      changeLanguage(state, payload) {
        app.$i18n.locale = payload;
        localStorage.setItem('currentLanguage', payload)
        state.currentLocale = payload
      },
    },
  actions: {
    setLanguage({commit}, payload) {
      if (process.env.NODE_ENV === "development") {
        console.log("$store/setLanguage", payload); // eslint-disable-line no-console
      }
      commit('changeLanguage', payload)
    },
    register(context, payload = {}) {
      const { moduleName } = payload;
      if (moduleName) {
        if (!this.state[moduleName]) {
          // console.log(this, moduleName);
        }
      }
    },
    ...actions
  },
  modules: {
    User,
    // MasterData,
    VdoSet,
    VdoSetUnit,
    VdoSetTopic,
    CommonData,
    Profile,
    Courses,
    StudentEnroll,
    StudentEnrollDetail,
    Examination,
    ClassRoomType,
    ClassRoomOwned,
    ClassRoom,
    Degree,
    SubjectGroup,
    Subject,
    Student,
    Teacher,
    CourseOutline,
    CourseOutlineRegistration,
    AcademicPeriodConfig,
    AcademicPeriod,
    ClassSection,
    LiveClassSchedule,
    VdoLiveSet,
    VdoLiveSetTopic,
    Exam,
    ExamQuestionType,
    ClassAssignment,
    ClassMaterial,
    StudentAssignment,
    StudentScore,
    StudentUnitLearn,
    StudentTopicLearn,
    Assessment,
    CourseOutlineAssessment,
    CourseOutlineUnit,
    Upload,
    CourseFaq,
    WebBoard,
    WebBoardReply,
    PrivateMessage,
    PrivateMessageReply,
    Notification,
    AdvisorOnlineSchedule,
    InfoGroup,
    InfoTopic,
    YeaLinkImportDate,
    SystemConfig,
  },
  strict: process.env.NODE_ENV !== 'production'
})
